import { useEffect, useRef } from 'react'

import { TemporaryTrackingState, TrackingService } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const useChatterActivityTracking = () => {
  const creatorId = useUnit($creatorId)
  const currentMinuteRef = useRef<number>(new Date().getMinutes())
  const activityRef = useRef<TemporaryTrackingState>(
    TemporaryTrackingState.INACTIVE,
  )
  const trackActivityMutation = useMutation(
    (state: TemporaryTrackingState) =>
      TrackingService.recordTrackingDashboard({
        creatorId: creatorId!,
        requestBody: {
          timestamp: new Date().toISOString(),
          state,
        },
      }),
    {
      onError: (error, state) => {
        handleError(error, 'Something went wrong while tracking activity', () =>
          trackActivityMutation.mutate(state),
        )
      },
    },
  )

  useEffect(() => {
    const handleActivity = () => {
      activityRef.current = TemporaryTrackingState.ACTIVE
    }

    document.addEventListener('keydown', handleActivity)
    document.addEventListener('mousedown', handleActivity)

    const interval = setInterval(() => {
      const currentMinute = new Date().getMinutes()

      if (currentMinute !== currentMinuteRef.current) {
        trackActivityMutation.mutate(activityRef.current)
        currentMinuteRef.current = currentMinute
        activityRef.current = TemporaryTrackingState.INACTIVE
      }
    }, 1000)

    return () => {
      document.removeEventListener('keydown', handleActivity)
      document.removeEventListener('mousedown', handleActivity)
      clearInterval(interval)
    }
  }, [trackActivityMutation])
}
